export default "__VITE_ASSET__DFrjDMhB__"